import AuthOptions from './AuthOptions';
import ThemeOptions from './ThemeOptions';

const options = {
  AuthOptions,
  ThemeOptions
};

export default  options;
